import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  NewOrder, Order, OrderMovement, OrderSearchParams, OrderUpdate, PageableOrders,
  StockCheckRequest, StockViolation
} from '../domain/order.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private apiUrl = environment.apiUrl + '/api/v1/order';

  constructor(private http: HttpClient) { }

  searchOrders(params: OrderSearchParams): Observable<PageableOrders> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http.get<PageableOrders>(`${this.apiUrl}/search`, { params: httpParams });
  }

  getOrder(orderId: number): Observable<Order> {
    return this.http.get<Order>(`${this.apiUrl}/${orderId}`);
  }

  validateStock(request: StockCheckRequest): Observable<StockViolation[]> {
    return this.http.post<StockViolation[]>(`${this.apiUrl}/validate-stock`, request);
  }

  // Real per-product available quantity (not just a violation when it's already exceeded) —
  // backs the Productos edit UI's live quantity cap, linked by productId.
  getAvailableQuantities(productIds: number[], excludeOrderId?: number): Observable<Record<number, number>> {
    let httpParams = new HttpParams().set('productIds', productIds.join(','));
    if (excludeOrderId != null) {
      httpParams = httpParams.set('excludeOrderId', excludeOrderId.toString());
    }
    return this.http.get<Record<number, number>>(`${this.apiUrl}/available-quantities`, { params: httpParams });
  }

  createOrder(order: NewOrder): Observable<Order> {
    return this.http.post<Order>(this.apiUrl, order);
  }

  updateOrder(orderId: number, order: OrderUpdate): Observable<Order> {
    return this.http.put<Order>(`${this.apiUrl}/${orderId}`, order);
  }

  // Cancels the order (status CANCELADA, closeReason set to the comment typed above) —
  // releases its stock reservation automatically since "reserved" only ever counts
  // not-CANCELADA orders.
  cancelOrder(orderId: number, comment: string): Observable<Order> {
    return this.http.post<Order>(`${this.apiUrl}/${orderId}/cancel`, { comment });
  }

  getOrderMovements(orderId: number): Observable<OrderMovement[]> {
    return this.http.get<OrderMovement[]>(`${this.apiUrl}/${orderId}/movements`);
  }

  addComment(orderId: number, comment: string): Observable<OrderMovement[]> {
    return this.http.post<OrderMovement[]>(`${this.apiUrl}/${orderId}/comments`, { comment });
  }
}
